module.exports = __webpack_public_path__ + "static/img/1901_6.da0fc43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1901_6.jpg
// module id = CB53
// module chunks = 1